import { Link } from "@tanstack/react-router";
import PrivacyBtn from "./PrivacyBtn";
import TermsBtn from "./TermsBtn";
import CaliforniaPrivacyBtn from "./CaliforniaPrivacyBtn";
import CookiePrivacyBtn from "./CookiePrivacyBtn";
import JobPostingRulesBtn from "./JobPostingRulesBtn";
import Author from "#/components/author";

export default function Footer({ fmBio }: { fmBio?: boolean }) {
  return (
    <>
      <footer className="w-full border-t border-gray-200 bg-white text-black">
        {fmBio && (
          <div className="mx-auto mt-10 max-w-2xl">
            <Author />
          </div>
        )}
        <div className="mx-auto flex max-w-screen-xl flex-wrap items-center justify-between p-4">
          <section className="text-black">
            <Link to="/">Roamdoc</Link> &#169; 2024 All Rights Reserved
          </section>
          <section>
            <nav className="mt-3 text-black">
              <Link to="/contact-roamdoc">Contact Roamdoc</Link>
            </nav>
          </section>
        </div>
        <section>
          <nav className="flex justify-center gap-4 px-1 py-5 text-sm text-gray-500">
            <PrivacyBtn />
            <CaliforniaPrivacyBtn />
            <TermsBtn />
            <CookiePrivacyBtn />
            <JobPostingRulesBtn />
          </nav>
        </section>
      </footer>
    </>
  );
}
